import React from 'react';
import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { defineCustomElements } from '@egov-moldova/mud-react';
import { AppProviders } from './app/providers';
import App from './App';
import './styles/global.css';

defineCustomElements();
dayjs.extend(relativeTime);
// dayjs' locale is not set here: it follows the chosen interface language, and
// app/language-side-effects.ts owns everything that does.

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Elementul rădăcină #root nu există în document.');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>,
);
